<!-- 推荐 -->
<template>
  <div class="mt-16 dis-flx al-c ju-c">
    <div class="fp_ip_wh mt-100">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="设置密码" prop="password">
          <el-input :type="flag ? 'password' : 'text'" v-model="ruleForm.password" autocomplete="off">
            <i slot="suffix" class="cur-poi"
              :class="[flag ? 'iconfont icon-biyan--' : 'iconfont icon-yanjing-zhengyan']"
              style="margin-top:8px;font-size:18px;" autocomplete="auto" @click="flag = !flag" />
          </el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="password2">
          <el-input :type="flag2 ? 'password' : 'text'" v-model="ruleForm.password2" autocomplete="off">
            <i slot="suffix" class="cur-poi"
              :class="[flag2 ? 'iconfont icon-biyan--' : 'iconfont icon-yanjing-zhengyan']"
              style="margin-top:8px;font-size:18px;" autocomplete="auto" @click="flag2 = !flag2" />
          </el-input>
        </el-form-item>
        <el-form-item class="mt-100">
            <!-- <el-button type="info" @click="goTop">上一步</el-button> -->
            <div class="ml-10">
              <el-button class="btn" type="primary" @click="submitForm('ruleForm')">下一步</el-button>
            </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { resetPassword } from "@/api/common";
import md5 from "js-md5";
import Axios from "axios";
import API_CONFIG from "../../../config/index.js"
export default {
  components: {

  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value.length < 6) {
        callback(new Error('密码最少6位'));
      } else {
        if (this.ruleForm.password2 !== '') {
          this.$refs.ruleForm.validateField('password2');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value.length < 6) {
        callback(new Error('密码最少6位'));
      } else if (value !== this.ruleForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      flag: true,
      flag2: true,
      ruleForm: {
        password: '',
        password2: ''
      },
      rules: {
        password: [
          { validator: validatePass, min: 6, required: true, trigger: 'blur' }
        ],
        password2: [
          { validator: validatePass2, min: 6, required: true, trigger: 'blur' }
        ],
      }
    };
  },

  watch: {},
  computed: {
    screenHeight: function () {
      return parseInt(document.documentElement.clientHeight) + 'px';

    }
  },
  created() {
  },
  mounted() {
    // this.drawLine();
  },
  methods: {
    submitForm(formName) {
      var that = this
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.resetPassword()

        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    resetPassword() {
      var that = this
      // console.log(localStorage.getItem('phone'))
      let phone = localStorage.getItem('phone')
      let paswor = this.ruleForm.password2
      let form = {
        phone:phone,
        newPassword:md5(paswor)
      }
      const res = Axios({
            method: "post",
            headers: {
              "Authorization": "Basic c2FiZXI6c2FiZXJfc2VjcmV0",
            },
            url: API_CONFIG.dev.proxyTable['/api'].target + "/userInfo/userinfo/reset-password",
            // url: "http://192.168.11.21:8686/blade-auth/oauth/token",
            params: form,
          }).then(function (res) {
            console.log(res,'res.coderes.coderes.code')
            if (res.data.code == 200) {
                that.$message({
                  type: "success",
                  message: res.data.msg,
                });
                localStorage.removeItem('phone');
                that.$emit('activeNum', 2)
              } else {
                that.$message({
                  type: "error",
                  message: res.data.msg
                });
              }

          });
      // resetPassword(form).then(res => {
      //   if (res.code == 200) {
      //     that.$message({
      //       type: "success",
      //       message: res.msg,
      //     });
      //     localStorage.removeItem('phone');
      //     this.$emit('activeNum', 3)
      //   } else {
      //     that.$message({
      //       type: "error",
      //       message: res.msg
      //     });
      //   }
      // });
    },
    goTop() {
      this.$emit('activeNum', 1)
    },
    jumpLogin() {
      this.$router.push({
        name: "login",
        params: {}
      })
    },
  }
};
</script>
<style>
  .bfa_self_btn2 .el-button--primary{
    background-color: #1067E0;
      border-color: #1067E0;
  }
</style>
<style scoped>
.pd-lr-260 {
  padding: 0 15%;
}

.pd-lrtb-230 {
  padding: 40px 80px 50px 25%;
}

.ft-co-ff1 {
  color: #FF1F1F;
}

.contentbox {
  width: 100%;
  height: 100%;
  background: #F4F4F4;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;

}

.ft-co-1C76EE {
  color: #1C76EE;
}

.hd_wh_gq {
  height: 80px;
  line-height: 80px;
  background: #FFFFFF;
  box-shadow: 0px 2px 16px 1px rgba(184, 184, 184, 0.25);
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  padding: 0 260px;
}

.wh_zc {
  height: 55px;
  background: #0392FF;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}

.pd-tb-30 {
  padding: 30px 0;
}

.fp_ip_wh {
  width: 400px;
}
>>>.el-input__inner {
    height: 56px;
    padding-left: 40px;
    line-height: 56px;
    font-size: 14px;
  }
  >>>.el-form-item__label{
    font-size: 17px;
    margin-top: 7px;
  }
  .btn {
    width: 100%;
    height: 50px;
    background: #0177FB;
    border-radius: 8px;
    border: 1px solid #0177FB;
    font-size: 24px;
    color: #FFFFFF;
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/forgetPassword/registerForm.vue